import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12  mb-5" }, null, -1)
const _hoisted_2 = { class: "col-xxl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionHistory = _resolveComponent("TransactionHistory")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TransactionHistory, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
    ])
  ], 64))
}